import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  model,
  OnInit, signal,
  ViewChild
} from '@angular/core';
import {
  ButtonComponent,
  ButtonOptions,
  FormComponent,
  InputComponent,
  InputOptions,
  ModalComponent, ModalOptions
} from "@shared/components";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormsModule,
  NgForm,
  ReactiveFormsModule, ValidationErrors,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {Coding} from '@core/classes/other/coding';
import {APIService, ToastService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {HTTPMethods, InputTypes, ModalTypes} from '@core/enums';
import {HttpHeaders} from '@angular/common/http';
import {lastValueFrom} from 'rxjs';
import {Response, ResponseSingle} from '@core/classes/other/response';
import {assets} from '@core/constants';
import {Insurance} from '@core/classes/tables/insurance';

@Component({
  selector: 'ncp-add-insurance',
  imports: [
    ButtonComponent,
    FormsModule,
    ModalComponent,
    InputComponent,
    ReactiveFormsModule
  ],
  templateUrl: './add-insurance.component.html',
  styleUrl: './add-insurance.component.scss',
})
export class AddInsuranceComponent implements OnInit, AfterViewInit {
  @ViewChild('mod') public mod!: ModalComponent;
  @ViewChild('insFrm') protected insuranceFormEl?: NgForm;
  @ViewChild('addInsuranceButton') public addInsuranceButton!: ButtonComponent;
  @ViewChild('name') public nameIn!: InputComponent;
  @ViewChild('number') public numberIn!: InputComponent;

  protected readonly toastService = inject(ToastService);

  private apiService = inject(APIService);
  private patientService = inject(PatientService);

  protected data = model<any>();

  protected form: FormGroup = new FormGroup({
    insurance_name: new FormControl<string>(''  ,[Validators.required]),
    insurance_number: new FormControl<string>('' ,[Validators.required]),
  }, {
    validators: [this.formValidator()]
  });

  formValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let errors: ValidationErrors | null = {};

      let name = (control as FormGroup).controls['insurance_name'];
      let number = (control as FormGroup).controls['insurance_number'];

      if(name.value === undefined || name.value === null || name.value === '') {
        name.setErrors({i_nameInvalid: true});
        errors['i_nameInvalid'] = true;
      }

      if(number.value === undefined || number.value === null || number.value === '') {
        number.setErrors({i_numberInvalid: true});
        errors['i_numberInvalid'] = true;
      }

      return Object.keys(errors).length > 0 ? errors : null;
    }
  }

  getFormControl = (name: string) => {
    return this.form.get(name) as FormControl;
  }


  public btnInsOptions = signal<ButtonOptions>(
    new ButtonOptions({
      id: 'insBtn',
      tooltip: 'add_insurance',
    })
  );

  protected nameInputOptions = signal<InputOptions>(
    new InputOptions({
      id: 'insuranceName',
      label: {
        text: 'insurance_name',
      },
      type: InputTypes.text,
      name: 'insurance_name',
      formControl: this.getFormControl('insurance_name'),
      initialValue: '',
      required: true
    })
  );

  protected numberInputOptions = signal<InputOptions>(
    new InputOptions({
      id: 'insuranceNumber',
      label: {
        text: 'insurance_number',
      },
      type: InputTypes.text,
      name: 'insurance_number',
      formControl: this.getFormControl('insurance_number'),
      initialValue: '',
      required: true
    })
  );

  protected modOptions = model<ModalOptions>(
    new ModalOptions({
      id: 'modal',
      type: ModalTypes.form,
      form: FormComponent,
      title: "add_insurance",
      options: {
        animation: true,
        size: 'xl',
        fullscreen: "lg",
        backdrop: 'static',
        keyboard: false,
      },
      onClose: () => {this.onFormReset()}
    })
  );

  ngOnInit() {
    this.btnInsOptions().onClick = () => {
      this.mod.options().onReset = this.onFormReset;
      this.addInsuranceButton.blur();
      this.mod.open();
    };

    this.modOptions().onSave = this.onSave;
  }

  onFormReset = () => {
    console.log('on reset form');
    this.form.reset();
    this.nameIn.reset();
    this.numberIn.reset();

    this.modOptions().errors = [];
  }

  ngAfterViewInit(): void {

  }

  onSave = () => {
    this.insuranceFormEl?.ngSubmit.emit();
  }

  validate = (): boolean => {
    Object.keys(this.form.controls).forEach((control) => {
      this.form.controls[control].markAsTouched();
    })

    return true;
  }

  onFormSubmit = () => {
    if(this.validate() && this.form.invalid) {
      console.log('this.form.is.invalid');
      this.modOptions().errors = this.form.errors!;
      this.mod.detectChanges();
      return;
    }

    this.modOptions().disableOnSave = true;
    var body: {[key: string]: any} = {
      insurance_name: this.form.get('insurance_name')?.value,
      insurance_number: this.form.get('insurance_number')?.value,
      status: 1,
      version_id: this.patientService.version!.new,
    }

    this.apiService.call({
      path: '/insurance',
      headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
      type: HTTPMethods.POST,
      body: body
    })?.subscribe((res: ResponseSingle<Insurance>) => {
      if(res && res.status?.toString() === '1') {
        let data = this.data()?.tblOptions().data
        data.unshift(res.data);
        if (this.data && this.data() && this.data().tbl && this.data().tbl.tableData) {
          this.data()!.tbl!.tableData! = data;
        }
        this.mod.close();
      }
    })
  }

  protected readonly assets = assets;
}
